import Axios from './Axios';
const API_URL = '/plans/';

export const plan = {
    get: () => Axios.get(API_URL + 'list'),
    getCharacteristics : ()=> Axios.get(API_URL + 'characteristics')
};
